<template>
    <div class="main-layout">
      <div class="main-layout-header">
        <LayoutHeader :is-workbench="true" />
      </div>
      <LegacyEnterpriseTouch />
      <EnterpriseBalanceAlertBanner />
      <div class="main-layout-content" ref="mainLayoutContent" id="main-layout-content">
        <div style="height: 100%;">
          <slot />
        </div>
        <!-- <LayoutFooter /> -->
      </div>
      <client-only>
        <el-backtop :right="25" :bottom="130" target="#main-layout-content" style="width: 60px;height: 60px;">
          <div class="desktop-backtop-icon">
            <i class="iconfont icon-icon_icon_to2" />
          </div>
        </el-backtop>
      </client-only>
    </div>
  </template>

  <script setup lang="ts">
  import LegacyEnterpriseTouch from '~/components/LegacyEnterprise/Touch.vue'
  import EnterpriseBalanceAlertBanner from '~/components/GlobalBiz/BalanceAlertBanner.vue'
  import useUserStore from '@/store/modules/user'
  const userStore = useUserStore()
  const route = useRoute()
  const { token, userInfo, bizTeamInfo } = storeToRefs(userStore)
  const enterpriseBalanceAlert = useEnterpriseBalanceAlert()

  watch(
    () => [route.path, token.value, userInfo.value?.bizTeamId, userInfo.value?.bizTeamMemberRole, bizTeamInfo.value?.serviceLevel],
    () => enterpriseBalanceAlert.refresh(),
    { immediate: true },
  )
  </script>
  
  <style scoped lang="scss">
  .main-layout {
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 100vh;
    .main-layout-header {
      width: 100%;
      position: sticky;
      top: 0;
      z-index: 100;
    }
    .main-layout-content {
      flex: 1;
      overflow-y: auto;
      width: 100%;
      min-height: 400px;
      display: flex;
      flex-direction: column;
    }

    .desktop-container-wrapper {
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
    }
  }
  .desktop-backtop-icon{
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      background: #FFFFFF;
      box-shadow: 0px 0px 20px 1px rgba(0,0,0,0.16);
      border-radius: 50%;
      .iconfont{
        font-size: 36px !important;
        color: #2590E1;
      }
    }
  </style>
